/** Layer order ids; data lives in ephemeral `Record<uuid, LocalGeotiffLayerState>` keyed by UUID only (suffix). */
export const PAINTBRUSH_LOCAL_GEOTIFF_PREFIX = "local-geotiff:" as const

export function paintbrushLocalGeotiffOrderId(internalId: string): string {
  return `${PAINTBRUSH_LOCAL_GEOTIFF_PREFIX}${internalId}`
}

/** Returns internal UUID when `layerOrderId` is a local GeoTIFF slot, otherwise null. */
export function parsePaintbrushLocalGeotiffOrderId(layerOrderId: string): string | null {
  if (!layerOrderId.startsWith(PAINTBRUSH_LOCAL_GEOTIFF_PREFIX)) {
    return null
  }
  return layerOrderId.slice(PAINTBRUSH_LOCAL_GEOTIFF_PREFIX.length)
}

/** Omit local preview slots before persisting `layer_order` server-side. */
export function omitPaintbrushLocalGeotiffsFromLayerOrder(layerOrder: string[]): string[] {
  return layerOrder.filter(id => !id.startsWith(PAINTBRUSH_LOCAL_GEOTIFF_PREFIX))
}
